export const ROUTE_ORDER_OVERVIEW = '/order'
export const ROUTE_ORDER_CREATE = `${ROUTE_ORDER_OVERVIEW}/create`
export const ROUTE_ORDER_CASH_REGISTER = `${ROUTE_ORDER_OVERVIEW}/cash-register`
export const ROUTE_ORDER_MAP = `${ROUTE_ORDER_OVERVIEW}/map`
export const ROUTE_ORDER_PRE_ORDERS = `${ROUTE_ORDER_OVERVIEW}/pre-orders`
export const ROUTE_ORDER_DETAIL = `${ROUTE_ORDER_OVERVIEW}/detail`
